import React, { useContext } from 'react';

import {
    useContactsSelector,
    useContactsSelectorDispatch,
} from '@components/ContactsSelector/Common/ContactsSelectorContext';
import ModelQuickFilters from '@components/ContactsSelector/ModelsSelector/ModelQuickFilters';
import { QuickFilterContainer } from '@components/Filters/FilterForm/FilterFormUI';
import RadioButtonGroup from '@components/Gui/NwForm/RadioButtonGroup';

const ModelsWallMiniHeader = ({ onAfterChangeFilters }) => {
    const { selection } = useContactsSelector();
    const cs_dispatch = useContactsSelectorDispatch();
    const { listType, quickFilters } = selection;

    let sortOptionsFolder = [
        { label: 'Name', value: 'Name' },
        { label: 'Manual', value: 'Manual' },
    ];

    const sortOptions = [
        { label: 'Name', value: 'Name' },
        { label: 'ID', value: 'ID' },
        { label: 'Agency', value: 'MotherAgency' },
    ];

    if (listType === 'all') {
        return <ModelQuickFilters onAfterChangeFilters={onAfterChangeFilters} isMini />;
    }
    if (listType === 'folders') {
        return (
            <QuickFilterContainer $isMini $topPadded>
                <div className="quick-filter-item">
                    <span className="before">sort by</span>
                    <RadioButtonGroup
                        value={quickFilters.sortFolder}
                        onChange={(value) => {
                            cs_dispatch({
                                type: 'ChangeQuickFilters',
                                quickFilters: {
                                    ...quickFilters,
                                    sortFolder: value,
                                },
                            });
                            if (onAfterChangeFilters) {
                                onAfterChangeFilters();
                            }
                        }}
                        size="small"
                        options={sortOptionsFolder}
                    />
                </div>
            </QuickFilterContainer>
        );
    }
    return (
        <QuickFilterContainer $isMini $topPadded>
            <div className="quick-filter-item">
                <span className="before">sort by</span>
                <RadioButtonGroup
                    value={quickFilters.sort}
                    onChange={(value) => {
                        cs_dispatch({
                            type: 'ChangeQuickFilters',
                            quickFilters: {
                                ...quickFilters,
                                sort: value,
                            },
                        });
                        if (onAfterChangeFilters) {
                            onAfterChangeFilters();
                        }
                    }}
                    size="small"
                    options={sortOptions}
                />
            </div>
        </QuickFilterContainer>
    );
};

export default ModelsWallMiniHeader;
